import React from 'react';
import { useLocation } from 'react-router-dom';
import { CurrentPageTitle } from './navbar.style';

interface CurrentPageProps {}

const CurrentPage: React.FC<CurrentPageProps> = () => {
	const location = useLocation();
	return (
		<CurrentPageTitle>{location.state?.currentPage ?? ''}</CurrentPageTitle>
	);
};

export default CurrentPage;
